import { render, staticRenderFns } from "./channelPhoneList.vue?vue&type=template&id=127a1e77&scoped=true"
import script from "./channelPhoneList.vue?vue&type=script&lang=js"
export * from "./channelPhoneList.vue?vue&type=script&lang=js"
import style0 from "./channelPhoneList.vue?vue&type=style&index=0&id=127a1e77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a1e77",
  null
  
)

export default component.exports